import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './BlogDetails';

const BlogDetailsSuspense = dynamic(() => import('./BlogDetails'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicBlogDetails(props: Props) {
	return <BlogDetailsSuspense {...props} />;
}
DynamicBlogDetails.displayName = 'DynamicBlogDetails';
